<nav class="tab-bar" [class.tab-bar--compact]="variant === 'compact'" role="tablist" [attr.aria-label]="ariaLabel">
  <button
    *ngFor="let tab of tabs; trackBy: trackByTabId"
    type="button"
    role="tab"
    [attr.aria-selected]="activeId === tab.id"
    [class.active]="activeId === tab.id"
    (click)="selectTab(tab)">
    <ion-icon *ngIf="tab.icon" [name]="tab.icon" aria-hidden="true"></ion-icon>
    <span class="tab-label">{{ tab.translateLabel ? (tab.label | translate) : tab.label }}</span>
    <span *ngIf="tab.count !== undefined" class="count-badge">{{ tab.count }}</span>
  </button>
</nav>